(function () {
  'use strict';

  angular.module('app').component('paymentProviderPage', paymentProviderDetailCtrl());

  function paymentProviderDetailCtrl() {
    return {
      bindings: {},
      controller: PaymentProviderDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/payment-providers/payment-provider-page.component.html',
    };
  }

  PaymentProviderDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'SessionService',
    'PaymentProviderService',

    // Angular downgraded service
    'companyService',
  ];

  function PaymentProviderDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    SessionService,
    PaymentProviderService,

    // Angular downgraded service
    companyService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_paymentprovider_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    // Methods
    vm.onPaymentProviderSaved = onPaymentProviderSaved;
    vm.onPaymentProviderCanceled = onPaymentProviderCanceled;

    // Initializers
    getPaymentProvider();
    getCompany();

    function getPaymentProvider() {
      if (itemId) {
        // edit
        vm.loadingItem = true;
        PaymentProviderService.getPaymentProvider(itemId).then(function (data) {
          vm.paymentProvider = data;
          vm.loadingItem = false;
        });
      } else {
        vm.paymentProvider = {};
      }
    }

    function getCompany() {
      var companyId = SessionService.getSelectedAccountCompany().id;

      // Try to respond only basic json from API
      vm.loadingCompany = true;
      companyService.getCompany(companyId, { skip_check_role: true }).subscribe((response) => {
        vm.company = response;

        vm.company.payment_methods = vm.company.payment_methods.filter(
          (method) => method.status == true
        );

        vm.loadingCompany = false;
      });
    }

    function onPaymentProviderSaved(item) {
      $location.path(`/payment_providers/${item.id}`);
    }

    function onPaymentProviderCanceled() {
      $location.path('/payment_providers');
    }
  }
})();
